// extracted by mini-css-extract-plugin
export default {"mensagem":"notificacoes_mensagem__q3Og8"};